import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function ShippingPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("sectionShipping")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                {t("sectionShippingDesc")}
              </p>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">How Shipping Costs Are Calculated</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  Shipping costs on AllChinaBuy depend on several factors. Understanding these variables helps you estimate costs and choose the most cost-effective shipping method for your needs.
                </p>
                <div className="grid sm:grid-cols-2 gap-4">
                  {[
                    { title: "Actual Weight", desc: "The physical weight of your parcel as measured on a scale." },
                    { title: "Volumetric Weight", desc: "Calculated from parcel dimensions: length × width × height ÷ volumetric divisor." },
                    { title: "Destination", desc: "Shipping costs vary significantly by country and region." },
                    { title: "Shipping Line", desc: "Different carriers offer different rates and delivery speeds." },
                    { title: "Parcel Size", desc: "Larger parcels may incur additional handling fees." },
                    { title: "Insurance", desc: "Optional insurance protects against loss or damage during transit." },
                  ].map((item) => (
                    <div key={item.title} className="p-4 rounded-xl bg-background-50 border border-background-200/50">
                      <h3 className="font-semibold text-sm text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-600">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Shipping Tips to Save Money</h2>
                <ul className="space-y-3 text-sm text-foreground-700">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span><strong>Consolidate packages:</strong> Combine multiple items into one shipment to reduce per-package fees.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span><strong>Remove packaging:</strong> Request removal of shoe boxes and excess packaging to reduce weight.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span><strong>Choose economy shipping:</strong> For non-urgent items, economy shipping lines offer significant savings.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span><strong>Compare shipping lines:</strong> Use the shipping calculator to compare different carriers before choosing.</span>
                  </li>
                </ul>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-primary-500/10 border border-primary-200/50 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">Ready to ship your items?</h3>
                <p className="text-foreground-600 mb-6 text-sm">Explore the AllChinaBuy spreadsheet and start building your haul today.</p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-block px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
                >
                  {t("heroCtaPrimary")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}